(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/javascripts/api-calls/api-call.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/javascripts/api-calls/api-call.js');

'use strict';

let drawgamesApiCaller;
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  drawgamesApiCaller = trinidadCore.components.require('tur', 'api-caller').drawgamesApiCaller;
} else {
  drawgamesApiCaller = svs.tur.apiCaller.drawgames;
}
async function fetchCharityPayouts(req) {
  let drawNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (drawNumber) {
    return drawgamesApiCaller.getCharityPayoutstatistics({
      req,
      drawIds: [drawNumber]
    });
  }
  return drawgamesApiCaller.getCharityPayoutstatistics({
    req
  });
}
async function fetchActiveCharities(req) {
  return drawgamesApiCaller.getCharityExternalcharities({
    req
  });
}
async function fetchCharityById(charityId, req) {
  return drawgamesApiCaller.getCharityExternalcharitiesById({
    req,
    charityId
  });
}
async function fetchCharityPayoutsWithCharities(req) {
  let drawNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const activeCharities = await fetchActiveCharities(req);
  const charityPayouts = await fetchCharityPayouts(req, drawNumber);
  return {
    activeCharities,
    charityPayouts
  };
}
async function postSelectCharity(_ref) {
  let clientSerial = _ref.clientSerial,
    charityId = _ref.charityId;
  const toApi = {
    retailerCustomerId: 0,
    productId: 'GEO1',
    clientSerial,
    charityId
  };
  const res = await drawgamesApiCaller.postGeoSelectCharity({
    data: toApi,
    jupiterVersion: 2
  });
  return res;
}
async function postCharitySub(_ref2) {
  let subscrId = _ref2.subscrId,
    charityId = _ref2.charityId;
  const toApi = {
    subscriptionId: subscrId,
    charityId
  };
  const res = await drawgamesApiCaller.postSubscriptionSelectCharity({
    data: toApi,
    jupiterVersion: 2
  });
  return res;
}
if (svs.isServer) {
  module.exports = {
    fetchActiveCharities,
    fetchCharityById,
    fetchCharityPayouts,
    fetchCharityPayoutsWithCharities
  };
} else {
  Object.assign(svs.lyckoplatsen.components.shared_charity.api_calls, {
    fetchActiveCharities,
    fetchCharityById,
    fetchCharityPayouts,
    fetchCharityPayoutsWithCharities,
    postSelectCharity,
    postCharitySub
  });
}

 })(window);